import {
  GET_RENEWAL_START,
  GET_RENEWAL_SUCCESS,
  GET_RENEWAL_FAILURE,
  GET_RENEWAL_RESET,
  FIND_RENEWAL_START,
  FIND_RENEWAL_SUCCESS,
  FIND_RENEWAL_FAILURE,
  FIND_RENEWAL_RESET,
  GETALL_RENEWAL_TRIGGER,
  GETALL_RENEWAL_TRIGGER_FAILED,
  GETALL_RENEWAL_TRIGGER_SUCCESS,
  CREATE_RENEWAL_TRIGGER,
  CREATE_RENEWAL_TRIGGER_FAILED,
  CREATE_RENEWAL_TRIGGER_SUCCESS,
  UPDATE_RENEWAL_TRIGGER,
  UPDATE_RENEWAL_TRIGGER_FAILED,
  UPDATE_RENEWAL_TRIGGER_SUCCESS,
  WHATSAPP_RENEWAL_MESSAGE,
  WHATSAPP_RENEWAL_MESSAGE_SUCCESS,
  WHATSAPP_RENEWAL_MESSAGE_FAILED,
  WHATSAPP_RENEWAL_MESSAGE_RESET,

} from "./actiontypes"


const initialState = {
  error: null,
  responseMsg: null,
  whatsappMsg: null,
  loading: false,
  renewal: [],
  renewalpolicy: [],
  autoRenewalTriggersList: [],
  isTriggerCreated: false
}

const RenewalReducer = (state = initialState, action) => {
  switch (action.type) {


    case GET_RENEWAL_START:
    case GETALL_RENEWAL_TRIGGER:
    case CREATE_RENEWAL_TRIGGER:
    case UPDATE_RENEWAL_TRIGGER:
    case WHATSAPP_RENEWAL_MESSAGE:
      return {
        ...state,
        loading: true,
        error: null,
        isTriggerCreated: false
      }

    case GET_RENEWAL_SUCCESS:
      //console.log(action.payload)
      return {
        ...state,
        loading: false,
        renewal: action.payload.data,

      }
    case WHATSAPP_RENEWAL_MESSAGE_RESET:
      return {
        ...state,
        whatsappMsg: null,
      }

    case GET_RENEWAL_FAILURE:
    case GETALL_RENEWAL_TRIGGER_FAILED:
    case CREATE_RENEWAL_TRIGGER_FAILED:
    case UPDATE_RENEWAL_TRIGGER_FAILED:
    case WHATSAPP_RENEWAL_MESSAGE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload,
        isTriggerCreated: false
      }

    case GET_RENEWAL_RESET:
      return {
        renewal: [],
        error: null,
        loading: false,
      }


    case FIND_RENEWAL_START:
      return {
        ...state,
        loading: true,
        error: null,
        responseMsg: "",

      }

    case FIND_RENEWAL_SUCCESS:
      console.log(action.payload.data)
      return {
        ...state,
        loading: false,
        renewal: action.payload.data,
        responseMsg: "",
      }

    case FIND_RENEWAL_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }
    case FIND_RENEWAL_RESET:
      return {
        ...state,
        renewal: [],
        error: null,
        loading: false,
      }
    case GETALL_RENEWAL_TRIGGER_SUCCESS:
      return {
        ...state,
        loading: false,
        autoRenewalTriggersList: action.payload,
        isTriggerCreated: false
      }
    case CREATE_RENEWAL_TRIGGER_SUCCESS:
    case UPDATE_RENEWAL_TRIGGER_SUCCESS:
      return {
        ...state,
        loading: false,
        responseMsg: action.payload,
        isTriggerCreated: true
      }
    case WHATSAPP_RENEWAL_MESSAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        responseMsg: action.payload,
      }
    default:
      return state
  }
};

export default RenewalReducer;